<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-start">
            <div v-if="exam.online">شرایط آزمون</div>
            <div v-else>توضیحات</div>
            <CButton
                v-if="exam.online && exam.status !== 'FINISHED'"
                class="px-lg-5 py-lg-2"
                color="primary"
                @click="editExamModal = true"
            >
              ویرایش
            </CButton>
          </CCardHeader>
          <CCardBody class="h-100">
            <ExamTeacherStatusBar :exam="exam"/>
            <EditExamModal
                v-model="editExamModal"
                :exam="exam"
                @get-exam="getExam"
            />
            <div v-if="exam.online" class="mt-4">
              <h5 class="d-flex justify-content-between align-items-start">
                نکات مهم:
              </h5>
              <div class="d-flex align-items-start text-center h-100">
                <ul
                    v-if="exam.notes.length"
                    class="text-sm text-right gray-700"
                >
                  <li
                      v-for="(note, index) in exam.notes"
                      :key="index"
                      class="note-text mt-2"
                  >
                    {{ note }}
                  </li>
                </ul>
                <CAlert v-else class="w-100" color="info"
                >نکته ای ثبت نشده است.
                </CAlert>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <StudentMultipleAnswerTable
            v-if="
            !showQuestion &&
            exam.type === 'MULTI_CHOICES' &&
            exam.status === 'FINISHED'
          "
        />
        <StudentTextAnswerTable
            v-if="
            !showQuestion && exam.type === 'TEXT' && exam.status === 'FINISHED'
          "
        />
        <QuestionsTable
            v-if="
            questions.length &&
            !showQuestion &&
            exam.online &&
            !editQuestionCard &&
            exam.status !== 'FINISHED'
          "
            :questions="questions"
            @get-questions="getQuestions"
            @edit-question="onEditQuestionCard"
            @show-question="onShowQuestion"
        />
        <FinishedExamQuestionTable
            v-if="
            questions.length &&
            !showQuestion &&
            exam.online &&
            !editQuestionCard &&
            exam.status === 'FINISHED'
          "
            :questions="questions"
            @get-questions="getQuestions"
            @show-question="onShowQuestion"
        />
        <MarkTable v-if="!exam.online" :klassId="klassId" @get-exam="getExam"/>
        <EditQuestionCard
            v-if="editQuestionCard"
            v-model="editQuestionCard"
            :question="selectedItem"
            @get-questions="getQuestions"
        />
        <MultipleAnswers
            v-if="
            (exam.type === 'MULTI_CHOICES' &&
              showQuestion &&
              !editQuestionCard) ||
            (exam.type === 'MULTI_CHOICES' && questions.length === 0)
          "
            class="w-100 text-right"
            @add-question="addQuestion"
        />
        <TextAnswers
            v-else-if="
            (exam.type === 'TEXT' && showQuestion && !editQuestionCard) ||
            (exam.type === 'TEXT' && questions.length === 0)
          "
            class="w-100 text-right"
            @add-question="addQuestion"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import MultipleAnswers from "@/components/Exam/MultipleAnswers.vue";
import TextAnswers from "@/components/Exam/TextAnswers.vue";
import ExamTeacherStatusBar from "@/components/Modals/Exam/ExamTeacherStatusBar.vue";
import EditExamModal from "@/components/Modals/Exam/EditExamModal.vue";
import QuestionsTable from "@/components/Exam/QuestionsTable.vue";
import MarkTable from "@/components/Exam/MarkTable.vue";
import EditQuestionCard from "@/components/Exam/EditQuestionCard.vue";
import StudentMultipleAnswerTable from "@/components/Exam/StudentMultipleAnswerTable.vue";
import StudentTextAnswerTable from "@/components/Exam/StudentTextAnswerTable.vue";
import FinishedExamQuestionTable from "../../../components/Exam/FinishedExamQuestionTable";

export default {
  name: "addExam",
  components: {
    FinishedExamQuestionTable,
    MultipleAnswers,
    TextAnswers,
    ExamTeacherStatusBar,
    EditExamModal,
    QuestionsTable,
    MarkTable,
    EditQuestionCard,
    StudentMultipleAnswerTable,
    StudentTextAnswerTable,
  },
  data() {
    return {
      loading: false,
      exam: {},
      editExamModal: false,
      questions: [],
      showQuestion: false,
      klassId: null,
      editQuestionCard: false,
      selectedItem: null,
    };
  },

  mounted() {
    this.getExam();
    this.getQuestions();
  },
  methods: {
    async getExam(routeName) {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}`);
        this.exam = data;
        this.klassId = data.courses[0].klass.id;
        routeName = data.title;
        this.$emit("go-to", routeName);
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getQuestions() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}/question`);
        this.questions = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async addQuestion(form) {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        // this.$emit("add-question", form);
        const payload = {
          text: form.text,
          fileUrl: form.files,
          choices: form.choices,
          correctAnswerIndex: form.correctAnswerIndex,
          randomizeChoice: form.randomizeChoice,
          mark: form.mark,
          type: this.exam.type,
        };
        await axios
            .post(`/exam/${examId}/question`, payload)
            .then((response) => {
              if (response.status === 200) {
                this.showQuestion = false;
                this.getQuestions();
                this.getExam();
              }
            });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onShowQuestion(value) {
      this.showQuestion = value;
    },
    onEditQuestionCard(item) {
      this.selectedItem = item;
      this.editQuestionCard = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  //min-height: 41vh;
  //height: calc(100% - 1.5rem);
}

.question__card {
  //min-height: calc(82vh + 1.5rem);
}

.note-text {
  word-wrap: break-word;
  white-space: pre-line;
  word-break: break-word;
}

ul {
  padding-inline-start: 20px;
}
</style>